export default "__VITE_ASSET__BUxTP5bD__"